
const Head =   `
<head>
  <title>GOM</title>
  <meta name="viewport" content="width=10000, initial-scale=1.0, maximum-scale=1.0, user-scalable=no">
   <link rel="stylesheet"
  href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"
  integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T" crossorigin="anonymous">
  
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.0/css/fontawesome.min.css" 
  integrity="sha512-RvQxwf+3zJuNwl4e0sZjQeX7kUa3o82bDETpgVCH2RiwYSZVDdFJ7N/woNigN/ldyOOoKw8584jM4plQdt8bhA==" 
  crossorigin="anonymous" referrerpolicy="no-referrer" />

  <style>
   
@page {
    size: A4 landscape;
}

.logo {
    width: 150px;
    height: auto;
}
.ent-head {
    display: flex;
    // padding: 5px;
    width: 100%;
}
.head-l {
    // padding: 3px;
    text-align: left;
    width: 50%;

}
.head-r {
    // padding: 3px;
    text-align: right;
    width: 50%;
}

.corps {
    display: flex;
    padding: 5px;

}
.receipt {
    // padding: 5px;
    box-sizing: border-box;
}
.receipt-left {
    width: 35%;
    // background-image: url("../../../../../../assets/images/logo/gom.png");
    // background-repeat: no-repeat;
    // background-size: 80% auto;
    // background-position: center;
    // opacity: .25;
}
.receipt-right {
    width: 65%;
    // background-image: url("../../../../../../assets/images/logo/gom.png");
    // background-repeat: no-repeat;
    // background-size: 80% auto;
    // background-position: center;
    // opacity: .25;

}
.receipt:not(:last-child) {
    border-right: 2px dashed #ccc;
    margin-rigth: 5px;
    margin-left: 5px;
}
.receipt-header,
.receipt-footer {
    text-align: center;
    width: 90%;
    // margin-bottom: 20px;
}
.card-recu{
    margin-top: 15px;
    margin-left: 5px;
    border: 1px solid #ccc;
}
.receipt-header h1,
.receipt-footer p {
    // margin: 2px 0;
}
.receipt-details {
    // margin-bottom: 2px;
    width: 100%;
    display:inline-flex;
    padding-bottom: 5px;
    // border-bottom: 1px solid #ccc;
}

.receipt-details-l {
    width: 50%;
    text-align: center;
}

.receipt-details-r {
    width: 50%;
    text-align: center;
}
 
.client-info {
    width: 100%;
    display: flex;
    justify-content: center;
    border: 1px solid #ccc;
    border-radius: 7px;
    font-size: small;
}

.client-info-l {
    width: 30%;
    text-align: center;
    background-color: #ccc;
    font-size: small;
}

.client-info-m {
    width: 30%;
    text-align: center;
    background-color: #ccc;
    font-size: small;
}

.client-info-r {
    width: 30%;
    text-align: center;
    background-color: #ccc;
    font-size: small;
}

.receipt-details p {
    // margin: 5px 0;
}

.tb-card{
    display: flex;
    margin-top: 10px;
}

.restPay{
    color: rgb(195, 31, 31);
}

.receipt-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 5px;
}
.receipt-table th,
.receipt-table td {
    border: 1px solid #000;
    padding: 3px;
}


</style>  
</head>`

export class CustomRecuToPDFs{
    constructor() {}

    static transferStockPDF(printContents,titre){
        return `
      <html>
      `+Head+`
        <body onload="window.print();">
          <div>
          `+printContents+`
          </div>
        </body>
      </html>`
    }
}
